module.exports = "/_next/static/files/4671d2fe0f63daf0e0a9f828bcb2a9e6.svg";